import { CDElement } from "./CDElement";
import { CDProperty } from "./CDProperty";
import { CDSelector } from "./CDSelector";

export class CDKeyFrames extends CDElement
{
  private _name:string;
  
  constructor( name:string )
  {
    super( CDElement.CDKeyFramesType );
    this._name = name;
  }

  getDefinition()
  {
    let keyframes = this.$$( CDElement.CDSelectorType ) as CDSelector[];
    
    let output:string[] = [];
    output.push( `@keyframes ${this._name}`);
    output.push( `{`);

    for ( let k of keyframes )
    {
      output.push(   k.selector );
      output.push( `  {`);

      for ( let c of k.children )
      {
        if ( c.isProperty )
        {
          let property = c as CDProperty;

          output.push( `    ${property.name}:${property.value};` );
        }
      }

     
      output.push( `  }`);
    }

    output.push( `}`);

    return output.join( "\n" );
  }
}